<template>
  <h1>
    正在登录中，请稍后...
  </h1>
</template>

<script>

export default {
  data () {
    return {
      wxCode: ""
    };
  },
  created () {
    console.log('zhixing')
    // this.getUser()



    this.wxCode = this.getCode("code") || null;
    if (this.wxCode) {
      this.setCode(this.wxCode);
    }
  },
  beforeDestroy () {


  },
  methods: {
    // 传递微信code码
    setCode (code) {
      // console.log(this.wxCode, "this.wxCode");
      // alert(code);
      var that = this;
      this.catReq1Service("/user/loginByWxAuthCode", { code: code })
        .then(function (response) {
          if (response.resultCode === "1") {
            var data = response.result;
            var val = JSON.stringify(data);
            localStorage.setItem("myUser", val);
            localStorage.setItem("myPhone", data.loginPhone); // 电话 
            localStorage.setItem("myId", data.selfCompany.id);
            localStorage.setItem("myUserImg", data.avatar); // 头像
            localStorage.setItem("myUserName", data.nickName); // 昵称
            localStorage.setItem("myAliasName", data.aliasName); // 别名  --
            localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
            that.getUser()// 判断用户是否绑定手机号
            this.$router.replace({ name: "home" }); // 跳到首页
          }
        })

    },
    // 从url获取code码
    getCode (name) {
      var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.href);
      return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    },
    getUser () {
      // 判断用户是否关联手机号
      let myPhone = localStorage.getItem("myPhone")
      // let temporaryId = localStorage.getItem("temporaryId")

      if (myPhone !== '') {
        // console.log('当前用户有手机号')
        this.$router.replace({ name: "home" }); // 跳到首页
      } else {
        this.$router.replace({ name: 'relation', params: { userId: '123' } });
        //this.$router.push('/login/relation');

      }
    }
  }
};
</script>
<style lang="less" scoped>
h1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>